export function favoriteIds(value: unknown): number[] {
  if (!Array.isArray(value)) {
    return [];
  }
  return Array.from(new Set(value.map(Number).filter((id) => Number.isInteger(id) && id > 0)));
}

export function isLimitReached(error: unknown): boolean {
  return JSON.stringify(error ?? '').includes('FAVORITES_LIMIT_REACHED');
}
